import main from '@/views/main'
import store from '@/store'
// login
const login = {
  path: '/login',
  name: 'Login',
  meta: {
    title: '登录',
  },
  component: resolve => {
    require(['@/views/login/login.vue'], resolve)
  },
}

// register
const register = {
  path: '/register',
  name: 'Register',
  meta: {
    title: '注册',
  },
  component: resolve => {
    require(['@/views/login/register.vue'], resolve)
  },
}

const registerSuccess = {
  path: '/register/success',
  name: 'RegisterSuccess',
  meta: {
    title: '注册',
  },
  component: resolve => {
    require(['@/views/login/register_success.vue'], resolve)
  },
}

const downloadQr = {
  path: '/register/download-qr',
  name: 'downloadQr',
  meta: {
    title: '下载app',
  },
  component: resolve => {
    require(['@/views/login/download-qr.vue'], resolve)
  },
}

// password_reset;
const passwordReset = {
  path: '/password_reset',
  name: 'PasswordReset',
  meta: {
    title: '重置密码',
  },
  component: resolve => {
    require(['@/views/login/password_reset.vue'], resolve)
  },
}

// user_agreement;
const userAgreement = {
  path: '/user_agreement',
  name: 'UserAgreement',
  meta: {
    title: '用户协议',
  },
  component: resolve => {
    require(['@/views/login/user_agreement.vue'], resolve)
  },
}
const tradePc = {
  path: '/tradePc',
  name: 'tradePc',
  meta: {
    title: 'tradePc',
  },
  component: resolve => {
    require(['@/views/tradePc/index.vue'], resolve)
  },
}
const tradeWap = {
  path: '/tradeWap',
  name: 'tradeWap',
  meta: {
    title: 'tradeWap',
  },
  component: resolve => {
    require(['@/views/tradeWap/index.vue'], resolve)
  },
}

// 500
const page500 = {
  path: '/500',
  name: 'error-500',
  meta: {
    title: '500 - 请求错误',
  },
  component: resolve => {
    require(['@/views/common/500.vue'], resolve)
  },
}

// 403
const page403 = {
  path: '/403',
  name: 'error-403',
  meta: {
    title: '403 - 无权限',
  },
  component: resolve => {
    require(['@/views/common/403.vue'], resolve)
  },
}

// 404
const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404 - 页面不存在',
  },
  component: resolve => {
    require(['@/views/common/404.vue'], resolve)
  },
}

const other = [
  {
    path: '/',
    component: main,
    meta: {
      title: 'home.ihome',
      icon: 'uc-menu-icon-index',
    },
    children: [
      {
        path: '/customer/details',
        name: 'customer-details',
        meta: {
          title: 'und.tinfom',
          pathWay: '2-1-1',
        },
        component: resolve => {
          require(['@/views/multiagent/details.vue'], resolve)
        },
      },
    ],
  },
]



export const routers = [
  {
    path: '/',
    component: main,
    meta: {
      title: 'home.ihome',
      icon: 'uc-menu-icon-index',
      pathWay: '1',
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        meta: { title: 'home.ihome', pathWay: '1-1' },
        component: resolve => {
          require(['@/views/home/home.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    meta: {
      title: 'menu.ib',
      icon: 'uc-menu-icon-jgkh',
      pathWay: '2',
    },
    component: main,
    children: [
      {
        path: '/customer',
        name: 'customer',
        meta: { title: 'menu.sib', pathWay: '2-1' },
        component: resolve => {
          require(['@/views/multiagent/customerIndex.vue'], resolve)
        },
      },
      {
        path: '/customerCount',
        name: 'customerCount',
        meta: { title: 'menu.stics', pathWay: '2-5' },
        component: resolve => {
          require(['@/views/multiagent/customerCount.vue'], resolve)
        },
      },
      {
        path: '/commManage',
        name: 'commManage',
        meta: { title: 'menu.sions', pathWay: '2-2' },
        component: resolve => {
          require(['@/views/multiagent/commManage.vue'], resolve)
        },
      },
      {
        path: '/reportView',
        name: 'reportView',
        meta: { title: 'menu.repview', pathWay: '2-3' },
        component: resolve => {
          require(['@/views/multiagent/reportView.vue'], resolve)
        },
      },
      {
        path: '/extensionlink',
        name: 'extensionlink',
        meta: { title: 'menu.rlink', pathWay: '2-4' },
        component: resolve => {
          require(['@/views/multiagent/extensionlink.vue'], resolve)
        },
      },
      {
        path: '/entryMoney',
        name: 'entryMoney',
        meta: { title: '存款管理', pathWay: '2-5' },
        component: resolve => {
          require(['@/views/multiagent/entryMoney.vue'], resolve)
        },
      },
      {
        path: '/exitMoney',
        name: 'exitMoney',
        meta: { title: '取款管理', pathWay: '2-6' },
        component: resolve => {
          require(['@/views/multiagent/exitMoney.vue'], resolve)
        },
      },
      {
        path: '/auditLog',
        name: 'auditLog',
        meta: { title: '审核日志', pathWay: '2-7' },
        component: resolve => {
          require(['@/views/multiagent/auditLog.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    meta: {
      title: 'menu.ainfo',
      icon: 'uc-menu-icon-zhzl',
      pathWay: '3',
    },
    component: main,
    children: [
      {
        path: '/basicMsg',
        name: 'basicMsg',
        meta: { title: 'basic.realname', pathWay: '3-1', auth: '0' },
        component: resolve => {
          require(['@/views/accountinfo/basicMsg.vue'], resolve)
        },
      },
      {
        path: '/basicMsgDaili',
        name: 'basicMsgDaili',
        meta: { title: '总代认证', pathWay: '3-1', auth: '0' ,hide: true},
        component: resolve => {
          require(['@/views/accountinfo/basicMsgDaili.vue'], resolve)
        },
      },
      {
        path: '/upDaili',
        name: 'upDaili',
        meta: { title: '申请代理', pathWay: '3-2',auth: '0',},
        component: resolve => {
          console.log(store.state.userRole,99999)
          require(['@/views/accountinfo/upDaili.vue'], resolve)
        },
      },
      {
        path: '/bankMsg',
        name: 'bankMsg',
        meta: { title: 'menu.bard', pathWay: '3-2' },
        component: resolve => {
          require(['@/views/accountinfo/bankMsg.vue'], resolve)
        },
      },
      {
        path: '/password',
        name: 'password',
        meta: { title: 'menu.cpass', pathWay: '3-3', auth: '0' },
        component: resolve => {
          require(['@/views/accountinfo/password.vue'], resolve)
        },
      },
      {
        path: '/buildmail',
        name: 'buildmail',
        meta: { title: 'menu.bemail', pathWay: '3-4', auth: '0' },
        component: resolve => {
          require(['@/views/accountinfo/buildmail.vue'], resolve)
        },
      },
      {
        path: '/buildphone',
        name: 'buildphone',
        meta: { title: 'menu.changephone', pathWay: '3-5', auth: '0' },
        component: resolve => {
          require(['@/views/accountinfo/buildphone.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    meta: {
      title: 'menu.mmange',
      icon: 'uc-menu-icon-zjgl',
      pathWay: '4',
    },
    component: main,
    children: [
      //{ path: '/antbag', name: 'antbag', meta: { title: '快捷支付', pathWay: '4-1' }, component: resolve => { require(['@/views/fund/antbag.vue'], resolve) } },
      {
        path: '/deposit',
        name: 'deposit',
        meta: { title: 'menu.injects', pathWay: '4-2', auth: '0' },
        component: resolve => {
          require(['@/views/fund/deposit-new.vue'], resolve)
        },
      },
      //{ path: '/transferPayment', name: 'transferPayment', meta: { title: '转账支付', pathWay: '4-3' }, component: resolve => { require(['@/views/fund/transferPayment.vue'], resolve) } },
      //{ path: '/bankremittance', name: 'bankremittance', meta: { title: '银行汇款', pathWay: '4-4' }, component: resolve => { require(['@/views/fund/bankremittance.vue'], resolve) } },
      //{ path: '/recharge', name: 'recharge', meta: { title: '商城支付', pathWay: '4-5' }, component: resolve => { require(['@/views/fund/recharge.vue'], resolve) } },
      //{ path: '/lightningPayment', name: 'lightningPayment', meta: { title: '网上充值', pathWay: '4-6' }, component: resolve => { require(['@/views/fund/lightningPayment.vue'], resolve) } },
      {
        path: '/withdraw',
        name: 'withdraw',
        meta: { title: 'menu.widraw', pathWay: '4-7' },
        component: resolve => {
          require(['@/views/fund/withdraw.vue'], resolve)
        },
      },
      {
        path: '/fundDetail',
        name: 'fundDetail',
        meta: { title: 'menu.fdet', pathWay: '4-8' },
        component: resolve => {
          require(['@/views/fund/fundDetail.vue'], resolve)
        },
      },
      {
        path: '/addressManage',
        name: 'addressManage',
        meta: { title: '钱包地址管理', pathWay: '4-9' },
        component: resolve => {
          require(['@/views/fund/addressManage.vue'], resolve)
        },
      },
   
    ],
  },

 
  {
    path: '/',
    meta: {
      title: 'menu.tradi',
      icon: 'uc-menu-icon-jyxx',
      pathWay: '5',
    },
    component: main,
    children: [
      {
        path: '/position',
        name: 'position',
        meta: { title: 'menu.posit', pathWay: '5-1' },
        component: resolve => {
          require(['@/views/tradeinfo/position.vue'], resolve)
        },
      },
      {
        path: '/closePosition',
        name: 'closePosition',
        meta: { title: 'menu.closep', pathWay: '5-2' },
        component: resolve => {
          require(['@/views/tradeinfo/closePosition.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    meta: {
      title: 'menu.actcen',
      icon: 'uc-menu-icon-activity',
      pathWay: '9',
    },
    component: main,
    children: [
     
      {
        path: '/activityList',
        name: 'activityList',
        meta: { title: 'menu.activityList', pathWay: '9-1' },
        component: resolve => {
          require(['@/views/activity/activityList.vue'], resolve)
        },
      },
      {
        path: '/myActivity',
        name: 'myActivity',
        meta: { title: 'menu.myActivity', pathWay: '9-2' },
        component: resolve => {
          require(['@/views/activity/myActivity.vue'], resolve)
        },
      },
      {
        path: '/activityDetail',
        name: 'activityDetail',
        meta: { title: 'menu.activityDetail', pathWay: '9-2', hide: true },
        component: resolve => {
          require(['@/views/activity/activityDetail.vue'], resolve)
        },
      },

      {
        path: '/activity',
        name: 'activetw',
        meta: { title: 'act.twbon', pathWay: '9-4', hide: true },
        component: resolve => {
          require(['@/views/activity/activetw.vue'], resolve)
        },
      },
      {
        path: '/trade',
        name: 'trade',
        meta: { title: 'tra.gift', pathWay: '9-5', hide: true },
        component: resolve => {
          require(['@/views/activity/activetrade.vue'], resolve)
        },
      },
      {
        path: '/marathon',
        name: 'marathon',
        meta: { title: 'menu.marathon', pathWay: '9-6', hide: true },
        component: resolve => {
          require(['@/views/activity/marathon.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    meta: {
      title: 'menu.servce',
      icon: 'uc-menu-icon-fwzx',
      pathWay: '6',
    },
    component: main,
    children: [
      {
        path: '/softDownload',
        name: 'softDownload',
        meta: { title: 'menu.down', pathWay: '6-1' },
        component: resolve => {
          require(['@/views/service/softDownload.vue'], resolve)
        },
      },
      // { path: '/crudeTrading', name: 'crudeTrading', meta: { title: '原油交易细则', pathWay: '6-2' }, component: resolve => { require(['@/views/service/crudeTrading.vue'], resolve) } },
      {
        path: '/suggestion',
        name: 'suggestion',
        meta: { title: 'menu.sugge', pathWay: '6-3' },
        component: resolve => {
          require(['@/views/service/suggestion.vue'], resolve)
        },
      },
      // 隐藏我的消息
      {
        path: '/myMsg',
        name: 'myMsg',
        meta: { title: 'menu.mymess', pathWay: '6-4' },
        component: resolve => {
          require(['@/views/service/myMsg.vue'], resolve)
        },
      },
      {
        path: '/contact',
        name: 'contact',
        meta: { title: 'menu.conus', pathWay: '6-5' },
        component: resolve => {
          require(['@/views/service/contact.vue'], resolve)
        },
      },
      {
        path: '/viewPDF',
        name: 'viewPDF',
        meta: { title: '操作指南', pathWay: '6-5' },
        component: resolve => {
          require(['@/views/service/viewPdf.vue'], resolve)
        },
      },
    ],
  },
  // {
  //   path: '/',
  //   component: main,
  //   meta: {
  //     title: '账户升级',
  //     icon: 'el-icon-upload2',
  //     pathWay: '7'
  //   },
  //   children: [
  //     { path: '/upGrade', name: 'upGrade', meta: { title: '账户升级', pathWay: '7-1' }, component: resolve => { require(['@/views/upgrade/upgrade.vue'], resolve) } },
  //   ]
  // },
  {
    path: '/',
    component: main,
    meta: {
      title: 'menu.invfri',
      icon: 'uc-menu-icon-ldx',
      pathWay: '7',
    },
    children: [
      {
        path: '/InvitingFriends',
        name: 'InvitingFriends',
        meta: { title: 'menu.invfris', pathWay: '7-1' },
        component: resolve => {
          require(['@/views/InvitingFriends/InvitingFriends.vue'], resolve)
        },
      },
      {
        path: '/BonusDetails',
        name: 'BonusDetails',
        meta: { title: 'menu.bonus', pathWay: '7-2' },
        component: resolve => {
          require(['@/views/InvitingFriends/BonusDetails.vue'], resolve)
        },
      },
      {
        path: '/SettlementRecord',
        name: 'SettlementRecord',
        meta: { title: 'menu.setrec', pathWay: '7-3' },
        component: resolve => {
          require(['@/views/InvitingFriends/SettlementRecord.vue'], resolve)
        },
      },
    ],
  },
  {
    path: '/',
    component: main,
    meta: {
      title: 'menu.firseven',
      icon: 'el-icon-star-off',
      pathWay: '8',
    },
    children: [
      {
        path: '/activity',
        name: 'activity',
        meta: { title: 'menu.firseven', pathWay: '8-1' },
        component: resolve => {
          require(['@/views/activity/activity.vue'], resolve)
        },
      },
    ],
  },
  

]

export default [
  ...routers,
  ...other,
  login, //登录页myMsg
  register, //注册
  registerSuccess,
  downloadQr,
  passwordReset, //重置密码
  userAgreement,
  page500,
  page403,
  tradePc,
  tradeWap,
  page404,
 
]



// WEBPACK FOOTER //
// ./src/router/router.js